<template>
  <a-layout-content class="wemail-sites-overview">
    <a-breadcrumb :style="{ marginBottom: '20px' }">
      <a-breadcrumb-item>
        <router-link tag="a" :to="{ name: 'sites.overview', params: { siteId: this.$route.params.siteId } }">Site</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>Site Settings</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="wemail-tabs-wrap">
      <SitesNavigation/>
      <div class="wemail-overview-content">
        <a-card title="Site owner info">
          <a-form :form="form" @submit.prevent="emailUpdate">
            <a-form-item label="Email">
              <a-input
                  v-if="editEmail"
                  v-decorator="[
                    'email',
                    {
                      initialValue: siteOwner.email,
                      rules: [
                        { type: 'email', message: 'The input is not valid E-mail!' },
                        { required: true, message: 'Please input your E-mail!' }
                      ],
                    },
                  ]"/>
              <span v-else style="padding-right: 10px">{{ siteOwner.email }}</span>
              <a-button type="primary" size="small" :icon="editEmail ? '' : 'edit'" @click.prevent="editEmail = !editEmail">
                {{ editEmail ? 'Cancel' : 'Edit' }}
              </a-button>
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 12, offset: 5 }" v-if="editEmail">
              <a-button type="primary" html-type="submit">
                Update
              </a-button>
            </a-form-item>
          </a-form>
        </a-card>
        <a-card title="Actions">
          <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="confirmDelete">
            <template slot="title">
              <p>Are you sure about to delete this site data completely?</p>
            </template>
            <a-button type="danger" icon="delete">
              Delete site
            </a-button>
          </a-popconfirm>
          <a-popconfirm v-if="block" placement="top" ok-text="Yes" cancel-text="No" @confirm="confirmUnblock">
            <template slot="title">
              <p>Are you sure about to unblock this site?</p>
            </template>
            <a-button type="info" icon="warning" style="margin-left: 15px">
              Unblock
            </a-button>
          </a-popconfirm>
          <a-popconfirm v-else placement="top" ok-text="Yes" cancel-text="No" @confirm="confirmBlock">
            <template slot="title">
              <p>Are you sure about to block this site?</p>
            </template>
            <a-button type="info" icon="warning" style="margin-left: 15px">
              Block
            </a-button>
          </a-popconfirm>
        </a-card>
      </div>
    </div>
  </a-layout-content>
</template>

<script>
import SitesNavigation from "@/components/SitesNavigation.vue";
import Api from "@/services/Api";
import _ from "lodash";

export default {
  components: { SitesNavigation },
  data() {
    return {
      status: 'all',
      siteOwner: {},
      site: {},
      editEmail: false,
      loading: true,
      block: false,
    };
  },

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'register' });
  },

  methods: {
    emailUpdate() {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.loading = true;
          Api.post(`sites/${this.$route.params.siteId}/settings`, values).then(res => {
            this.$weNotify("success", res.data.message);
            this.siteOwner = res.data.site_owner;
            this.editEmail = false;
            this.loading = false;
          }).catch(err => {
              let fields = {};

              _.each(err.response.data.errors, (value, key) => {
                let message = _.isArray(value) ? value[0] : value;

                fields[key] = {
                  value: values[key],
                  errors: [{ required: true }, { message: message }]
                };
              });

              this.form.setFields(fields);
            }).then(() => (this.loading = false));
            this.loading = false;
        }
      });
    },

    confirmDelete() {
      Api.delete(`sites/${this.$route.params.siteId}`).then(res => {
        this.$weNotify("success", res.data.message);
        this.$router.push({ name: 'sites.index' })
        this.loading = false;
      }).catch(err => {
        this.$weNotify("error", err.message);
      }).then(() => (this.loading = false));
    },

    confirmUnblock() {
      Api.post(`/sites/${this.$route.params.siteId}/unblock`).then(res => {
        this.loadSiteBlockStatus();
        this.$weNotify("success", res.data.message);
      })
    },

    confirmBlock() {
      Api.post(`/sites/${this.$route.params.siteId}`).then(res => {
        this.loadSiteBlockStatus();
        this.$weNotify("success", res.data.message);
      })
    },

    loadSiteBlockStatus() {
      Api.get(`sites/${this.$route.params.siteId}/status`).then(res => {
        this.block = res.data.isBlocked
      })
    },

    loadSiteOverviewData() {
      this.loading = true;
      Api.get(`sites/${this.$route.params.siteId}/owner`).then(res => {
        this.siteOwner = res.data.owner;
        this.site = res.data.site;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
      this.loadSiteBlockStatus();
    }
  },
  created() {
    this.loadSiteOverviewData();
  },
};
</script>
<style  scoped>
.wemail-sites-overview {
  margin: 30px;
}
.wemail-overview-content {
  padding: 15px;
  background: #fafafa;
}
.wemail-overview-content table {
  border: 1px solid #e8e8e8;
}
.wemail-tabs-wrap {
  border: 1px solid #d9d9d9;
}
</style>
